// import _ from 'lodash'
import { f_rules } from './commonUtils'

export const CustomDataMixin = {
    props: [
        'o_data', 'c_type', 'r_type', 'selected_reports', 'show_info', 'uom', 'is_multirange'
    ],
    data() {
        return {
            c_data: null,
            rules: f_rules,
            emptyRules: [
                v => !!v || 'valore richiesto'
            ],
            valid: {}
        }
    },
    mounted() {
        this.c_data = _.cloneDeep(this.o_data)
    },
    methods: {
        getData() {
            // console.log('CUSTOM DATA', this.c_data)
            return this.c_data
        },
        isValid() {
            return this.valid[this.c_type]
        },
        prova(){
            console.log("$$ ciao")
        }

    }
}